import React from 'react';
import { useTranslation } from 'react-utilities';
import { TPunishment } from '../../utils/types';
import { NAPageItemConfigType, PageItemRenderingProps } from '../ConfigTypes';

/**
 * Message regarding DSA regulations that requires disclosure about automated process
 * involved in issuing consequence
 */
const ConsequenceTransparencyPageItem = (props: PageItemRenderingProps): JSX.Element => {
  const { translate } = useTranslation();
  const { punishmentData } = props;
  return (
    <div data-testid='consequence-transparency'>
      {/* eslint-disable-next-line react/jsx-no-literals */}
      <span>{translate('Label.Decision')}: </span>
      <b>{punishmentData.consequenceTransparencyMessage}</b>
    </div>
  );
};

const ConsequenceTransparencyPageItemConfig: NAPageItemConfigType = {
  getIsVisible: (punishmentData: TPunishment) => {
    return !!punishmentData.consequenceTransparencyMessage;
  },
  renderComponent: ConsequenceTransparencyPageItem,
  configName: 'consequence-transparency'
};

export default ConsequenceTransparencyPageItemConfig;
